type Props = {
  color: 'black' | 'green';
};

const styles = {
  black: '#101010',
  green: '#53c855',
};

export const ArrowDownInCircle = ({ color = 'black' }: Props) => {
  return (
    <svg
      style={{ marginLeft: '8px' }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" stroke={styles[`${color}`]} />
      <path
        d="M10.2426 10.5C10.5188 10.5 10.7426 10.2761 10.7426 9.99996L10.7426 5.49996C10.7426 5.22382 10.5188 4.99996 10.2426 4.99996C9.9665 4.99996 9.74264 5.22382 9.74264 5.49996L9.74264 9.49996L5.74264 9.49996C5.4665 9.49996 5.24264 9.72382 5.24264 9.99996C5.24264 10.2761 5.4665 10.5 5.74264 10.5L10.2426 10.5ZM5.64645 6.11088L9.88909 10.3535L10.5962 9.64641L6.35355 5.40377L5.64645 6.11088Z"
        fill={styles[`${color}`]}
      />
    </svg>
  );
};
